module.exports = __webpack_public_path__ + "static/media/masterCard.37ddab8b.png";